import { all, fork, put, takeLatest } from 'redux-saga/effects';
import {
  ACTION_REQUEST_PLANS,
  ACTION_REQUEST_PLAN_DETAIL,
  ACTION_CANCEL_SUBSCRIPTION,
  ACTION_RESTORE_SUBSCRIPTION,
  ACTION_BUY_PLAN,
  ACTION_SUBSCRIPTION_PAYMENT,
  ACTION_ENTERPRISE_REQUEST,
  REQUEST_PLANS_FAILURE,
  REQUEST_PLAN_DETAIL_FAILURE,
  REQUEST_CANCEL_SUBSCRIPTION_SUCCESS,
  REQUEST_CANCEL_SUBSCRIPTION_FAILURE,
  REQUEST_RESTORE_SUBSCRIPTION_SUCCESS,
  REQUEST_RESTORE_SUBSCRIPTION_FAILURE,
  REQUEST_BUY_PLAN_FAILURE,
  REQUEST_SUBSCRIPTION_PAYMENT_FAILURE,
  REQUEST_ENTERPRISE_REQUEST_SUCCESS,
  REQUEST_ENTERPRISE_REQUEST_FAILURE,
  getPlansAPI,
  getPlanDetailAPI,
  cancelSubscriptionAPI,
  restoreSubscriptionAPI,
  buyPlanAPI,
  createSubscriptionPaymentAPI,
  submitEnterpriseRequestAPI,
} from './index';
import { showToastAlert } from '../app';
import { getErrorMessage, isUnauthorized } from '../../../utils/error';
import { LOGOUT_ACTION } from '../auth';

function* handleGetPlans() {
  yield takeLatest([ACTION_REQUEST_PLANS], function* () {
    yield put(getPlansAPI());
  });

  yield takeLatest([REQUEST_PLANS_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);
    yield put(showToastAlert(errorMessage || 'Failed to load plans!', 'error'));

    if (isUnauthorized(action.payload)) {
      yield put({
        type: LOGOUT_ACTION,
      });
    }
  });
}

function* handleGetPlanDetail() {
  yield takeLatest([ACTION_REQUEST_PLAN_DETAIL], function* (action) {
    const planId = action.payload;
    if (planId) {
      yield put(getPlanDetailAPI(planId));
    }
  });

  yield takeLatest([REQUEST_PLAN_DETAIL_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);
    yield put(showToastAlert(errorMessage || 'Failed to load plan detail!', 'error'));

    if (isUnauthorized(action.payload)) {
      yield put({
        type: LOGOUT_ACTION,
      });
    }
  });
}

function* handleCancelSubscription() {
  yield takeLatest([ACTION_CANCEL_SUBSCRIPTION], function* () {
    yield put(cancelSubscriptionAPI());
  });

  yield takeLatest([REQUEST_CANCEL_SUBSCRIPTION_SUCCESS], function* () {
    yield put(showToastAlert('Subscription canceled successfully!', 'success'));
    // Reload plans to reflect the change
    yield put(getPlansAPI());
  });

  yield takeLatest([REQUEST_CANCEL_SUBSCRIPTION_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);
    yield put(showToastAlert(errorMessage || 'Failed to cancel subscription!', 'error'));

    if (isUnauthorized(action.payload)) {
      yield put({
        type: LOGOUT_ACTION,
      });
    }
  });
}

function* handleRestoreSubscription() {
  yield takeLatest([ACTION_RESTORE_SUBSCRIPTION], function* () {
    yield put(restoreSubscriptionAPI());
  });

  yield takeLatest([REQUEST_RESTORE_SUBSCRIPTION_SUCCESS], function* () {
    yield put(showToastAlert('Subscription restored successfully!', 'success'));
    // Reload plans to reflect the change
    yield put(getPlansAPI());
  });

  yield takeLatest([REQUEST_RESTORE_SUBSCRIPTION_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);
    yield put(showToastAlert(errorMessage || 'Failed to restore subscription!', 'error'));

    if (isUnauthorized(action.payload)) {
      yield put({
        type: LOGOUT_ACTION,
      });
    }
  });
}

function* handleBuyPlan() {
  yield takeLatest([ACTION_BUY_PLAN], function* (action) {
    const planId = action.payload;
    if (planId) {
      yield put(buyPlanAPI(planId));
    }
  });

  yield takeLatest([REQUEST_BUY_PLAN_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);
    yield put(showToastAlert(errorMessage || 'Failed to create order!', 'error'));

    if (isUnauthorized(action.payload)) {
      yield put({
        type: LOGOUT_ACTION,
      });
    }
  });
}

function* handleSubscriptionPayment() {
  yield takeLatest([ACTION_SUBSCRIPTION_PAYMENT], function* (action) {
    const paymentData = action.payload;
    if (paymentData) {
      yield put(createSubscriptionPaymentAPI(paymentData));
    }
  });

  yield takeLatest([REQUEST_SUBSCRIPTION_PAYMENT_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);
    yield put(showToastAlert(errorMessage || 'Failed to process payment!', 'error'));

    if (isUnauthorized(action.payload)) {
      yield put({
        type: LOGOUT_ACTION,
      });
    }
  });
}

function* handleEnterpriseRequest() {
  yield takeLatest([ACTION_ENTERPRISE_REQUEST], function* (action) {
    const requestData = action.payload;
    if (requestData) {
      yield put(submitEnterpriseRequestAPI(requestData));
    }
  });

  yield takeLatest([REQUEST_ENTERPRISE_REQUEST_SUCCESS], function* () {
    yield put(showToastAlert('Your request has been submitted successfully! We will contact you soon.', 'success'));
  });

  yield takeLatest([REQUEST_ENTERPRISE_REQUEST_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);
    yield put(showToastAlert(errorMessage || 'Failed to submit request. Please try again.', 'error'));

    if (isUnauthorized(action.payload)) {
      yield put({
        type: LOGOUT_ACTION,
      });
    }
  });
}

function* loadPlansData() {
  yield put(getPlansAPI());
}

export function* loadPlansPage() {
  yield all([
    fork(loadPlansData),
    fork(handleGetPlans),
    fork(handleGetPlanDetail),
    fork(handleCancelSubscription),
    fork(handleRestoreSubscription),
    fork(handleBuyPlan),
    fork(handleSubscriptionPayment),
    fork(handleEnterpriseRequest),
  ]);
}
